import PropTypes from 'prop-types'
import { useRef, useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { Element } from '../html/element'
import DropdownTooltip from './DropdownTooltip'
import classes from './textEllipsisStaticLine.module.scss'

export const TextEllipsisStaticLine = ({
  text,
  isI18n,
  zIndexTooltip,
  appendStyle,
  lineClamp,
  tooltipMaxWidthByContent,
  tooltipStyle,
}) => {
  const ellipsisRef = useRef()

  const [isOpenTooltip, setIsOpenTooltip] = useState(false)

  const onMouseEnter = () => {
    const isConditionOverflowActive = (event) => {
      return (
        event.offsetHeight < event.scrollHeight ||
        event.offsetWidth < event.scrollWidth
      )
    }
    if (isConditionOverflowActive(ellipsisRef.current)) {
      setIsOpenTooltip(true)
    }
  }

  const onMouseLeave = () => {
    setIsOpenTooltip(false)
  }

  return (
    <Element
      ref={ellipsisRef}
      className={classes.ellipsisStaticLine}
      style={{
        ...appendStyle,
        lineClamp,
        WebkitLineClamp: lineClamp,
      }}
    >
      <span onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        {isI18n ? <Translate value={text} /> : text}
      </span>
      {isOpenTooltip && (
        <DropdownTooltip
          containerRef={ellipsisRef}
          text={text}
          isOpenTooltip={isOpenTooltip}
          zIndexTooltip={zIndexTooltip}
          isI18n={isI18n}
          tooltipMaxWidthByContent={tooltipMaxWidthByContent}
          childStyle={tooltipStyle}
        />
      )}
    </Element>
  )
}

TextEllipsisStaticLine.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  appendStyle: PropTypes.object,
  isI18n: PropTypes.bool,
  lineClamp: PropTypes.number,
  tooltipMaxWidthByContent: PropTypes.bool,
  zIndexTooltip: PropTypes.number,
  tooltipStyle: PropTypes.object,
}

TextEllipsisStaticLine.defaultProps = {
  text: '',
  appendStyle: {},
  isI18n: true,
  lineClamp: 2,
  tooltipMaxWidthByContent: false,
  zIndexTooltip: 1,
  tooltipStyle: {},
}
